var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"wrapper table-wrapper pa-0 ma-0"},[_c('iframe',{staticClass:"ai-cfo-frame",attrs:{"id":"ai-cfo-frame","data-ai-cfo":"","src":_vm.iframeSrc,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }